import axios from '../../services/axios';

const BASE = '/career-directions';
const unwrap = (res) => res.data.data;

export const careerDirectionApi = {
    mine: () => axios.get(`${BASE}/me`).then(unwrap),
    interns: (params) => axios.get(`${BASE}/admin/interns`, { params }).then(unwrap),
    exportCsv: (params) => axios.get(`${BASE}/admin/export`, { params, responseType: 'blob' }).then((res) => res.data),
    setGroup: (profileId, code) => axios.post(`${BASE}/admin/interns/${profileId}/degree-group`, { code }).then(unwrap),
    setTitle: (profileId, title) => axios.post(`${BASE}/admin/interns/${profileId}/title`, { title }).then(unwrap),
    resetTitle: (profileId) => axios.post(`${BASE}/admin/interns/${profileId}/reset-title`).then(unwrap),
    autoGroup: (profileId) => axios.post(`${BASE}/admin/interns/${profileId}/auto-group`).then(unwrap),
    previewCsv: (csv) => axios.post(`${BASE}/admin/backfill/preview`, { csv }).then(unwrap),
    commitCsv: (csv) => axios.post(`${BASE}/admin/backfill/commit`, { csv }).then(unwrap),
    groups: () => axios.get(`${BASE}/admin/groups`).then(unwrap),
    updateGroup: (code, body) => axios.put(`${BASE}/admin/groups/${code}`, body).then(unwrap),
    settings: () => axios.get(`${BASE}/admin/settings`).then(unwrap),
    updateSettings: (body) => axios.put(`${BASE}/admin/settings`, body).then(unwrap)
};

export function errorMessage(error, fallback = 'Something went wrong') {
    return error?.response?.data?.message || fallback;
}
